namespace Gordic.Pod.ListPrefabs {
    //export function IxpColumn<TRow = any>(
    //    gridColumn?: GGridColumn<TRow>
    //): Gordic.Data.GridFormat<TRow> {
    //    return new Gordic.Data.GridFormat<TRow>()
    //        .addTextColumn($.extend(true, {
    //            name: "ixp",
    //            caption: "jres:23900143",
    //            width: 110,
    //        }, gridColumn));
    //}

    export function ixbColumn(): GGridColumn<any>
    {
        return {
            name: "ixb",
            caption: "jres:23900019", //RC 23900019 : PID el. podání
            width: Gordic.Wfl.ListPrefabs.GridSirkaPID,            
        }
    }

    export function StavNaPodatelneColumn(): GGridColumn<any> {
        return {
            name: "s_pio_txt",
            caption: "jres:23900125", //RC 23900125 : Stav na podatelně
            width: 120,
        }
    }

    export function PodCisloColumn(): GGridColumn<any> {
        return {
            name: "pod_cis",
            caption: "jres:31950107", //RC 31950107 : Podací číslo
            width: 120,
        }
    }

    export function IDZpravyColumn(): GGridColumn<any> {
        return {
            name: "message_id",
            caption: "jres:23900021", //RC 23900021 : ID zprávy
            width: 110,
        }
    }

    export function IDCorrelation(): GGridColumn<any> {
        return {
            name: "correlation_id",
            caption: "ID corelacion", 
            width: 110,
        }
    }


    export function UIDLColumn(): GGridColumn<any> {
        return {
            name: "uidl",
            caption: "jres:23900022", //RC 23900022 : UIDL
            width: 110,
        }
    }

    export function datPrijColumn(): GGridColumn<any> {
        return {
            name: "dat_prij",
            caption: "jres:23900025", //RC 23900025 : Dat. stažení
            width: Gordic.Wfl.ListPrefabs.GridSirkaDatum,
        }
    }

    export function nazevFunkceZpracovateleColumn(): GGridColumn<any> {
        return {
            name: "nazev_fun_zprac",
            caption: "jres:23900024", //RC 23900024 : Zpracovatel el. podání
            width: Gordic.Wfl.ListPrefabs.GridSirkaNazev,
        }
    }

    export function nazevFunkceZmenuProvedl(): GGridColumn<any> {
        return {
            name: "nazev_fun_zprac",
            caption: "jres:23900047", //RC 23900047 : Poslední změnu provedl
            width: Gordic.Wfl.ListPrefabs.GridSirkaNazev,
        }
    }

    export function IconStavRozlozeni(delegate: ObjectLiteral<Gordic.Wfl.WebClient.GIcon>): GGridColumn<any> {
        return {
            caption: "jres:23900038", //RC 23900038 : Stav rozložení
            name: "IconStavRozlozeni",
            field: "stav_rozlozeni_bmp",
            iconTemplate: function (row) {
                return Gordic.Wfl.Common.GetIconTemplate(delegate[row.stav_rozlozeni_bmp]);
            }
        }
    }

    export function DelegateRezimZpracovani(): GGridColumn<any> {
        return {
            caption: "jres:23900213", //RC 23900213 : Režim zpracování (manuál / automat)
            name: "DelegateRezimZpracovani",
            field: "priz_automat",
            iconTemplate: function (row: any) {
                switch (row.priz_automat) {
                    case 0: return { icon: Gin.Icons.ZpusobZpracovani.rucne, tooltip: "jres:23900215" }; //RC 23900215 : Manuál
                    case 1: return { icon: Gin.Icons.ZpusobZpracovani.automaticky, tooltip: "jres:23900214" }; //RC 23900214 : Automat
                    default: return null;
                }
            }
        }
    }

    export function SekceFilterDleTypuDatumu(opt?: GRadioOptions<any>): Gordic.Forms.FormRow[] {
        const fieldOptions: GRadioOptions<any> = {
            name: opt && opt.name ? opt.name : "FiltrDleDatumu",
            radios: opt && opt.radios ? opt.radios : 
                [
                    { value: Wfl.Interface.TypFiltrDleDatumu.Podani, label: 'jres:31950068' }, //RC 31950068 : Datum podání
                    { value: Wfl.Interface.TypFiltrDleDatumu.Zmeny, label: 'jres:31950069' }, //RC 31950069 : Datum změny
                ],
            initialValue: opt && opt.initialValue != null ? { val: opt.initialValue } : Wfl.Interface.TypFiltrDleDatumu.Zmeny
        };

        return Gin.Prefabs.preReturn(new Gordic.Forms
            .Form({ name: "SekceFilterDleTypuDatumu" })
            .addSection()
            .addRow("")
            .addField("gradio", opt, fieldOptions));
    }

    export function SekceFilterDlePodepsani(opt?: GSelectBoxOptions<any>): Gordic.Forms.FormRow[] {
        const fieldOptions: GSelectBoxOptions<any> = {
            name: opt && opt.name ? opt.name : "Podepsani",
            list: opt && opt.list != undefined ? opt.list : true,
            data: new Gordic.Data.View([
                { val: Wfl.Interface.FiltrDlePodpisuEnum.Vsechny, text: 'jres:23900004' }, //RC 23900004 : vše
                { val: Wfl.Interface.FiltrDlePodpisuEnum.Podepsane, text: 'jres:23900008' }, //RC 23900008 : podepsané
                { val: Wfl.Interface.FiltrDlePodpisuEnum.Nepodepsane, text: 'jres:23900009' }, //RC 23900009 : nepodepsané
            ], { key: "val" }),
            itemTemplate: opt && opt.itemTemplate ? opt.itemTemplate : "{text}",
            model: opt && opt.model ? opt.model : "model.Podepsani=value.val",
            itemWidth: opt && opt.itemWidth ? opt.itemWidth : "",
            initialValue: opt && opt.initialValue != null ? { val: opt.initialValue } : Wfl.Interface.FiltrDlePodpisuEnum.Vsechny
        };

        return Gin.Prefabs.preReturn(new Gordic.Forms
            .Form({ name: "PodepsaniPrefabForm" })
            .addSection()
            .addRow("jres:23900007") //RC 23900007 : Podpis
            .addField("gselectbox", opt, fieldOptions));
    }

    export function SekceFilterDleZpusobuDoruceni(opt?: {
        email?: GCheckOptions,
        ElNosic?: GCheckOptions
        DS?: GCheckOptions
        GEX?: GCheckOptions
        WebPodatelna?: GCheckOptions
        RAP?: GCheckOptions
        interni?: GCheckOptions
        portal?: GCheckOptions
        ostatni?: GCheckOptions
    }): Gordic.Forms.FormRow[] {
        if (!opt) {
            // Abych neustálne nemusel kontrolovat objekt opt.
            opt = {
                //radios: undefined,
                //initialValue: '0'
            };
        }

        const fieldEmailOptions: GCheckOptions = {
            name: opt.email && opt.email.name ? opt.email.name : "TypPrijmu_EMail",
            label: opt.email && opt.email.name ? opt.email.name : "jres:23900011", emptyValue: true
        };

        const fieldElNosicOptions: GCheckOptions = {
            name: opt.ElNosic && opt.ElNosic.name ? opt.ElNosic.name : "TypPrijmu_DatovyNosic",
            label: opt.ElNosic && opt.ElNosic.name ? opt.ElNosic.name : "jres:23900012"
        };

        const fieldDsOptions: GCheckOptions = {
            name: opt.DS && opt.DS.name ? opt.DS.name : "TypPrijmu_DS",
            label: opt.DS && opt.DS.name ? opt.DS.name : "DS"
        };

        const fieldGEXOptions: GCheckOptions = {
            name: opt.GEX && opt.GEX.name ? opt.GEX.name : "TypPrijmu_GEX",
            label: opt.GEX && opt.GEX.name ? opt.GEX.name : "GEX"
        };

        const fieldRAPWebPodatelnaOptions: GCheckOptions = {
            name: opt.WebPodatelna && opt.WebPodatelna.name ? opt.WebPodatelna.name : "TypPrijmu_EPodatelnaRAP",
            label: opt.WebPodatelna && opt.WebPodatelna.name ? opt.WebPodatelna.name : "jres:23900238" //RC 23900238 : RAP/OSP
        };

        const fieldInterniVypraveniOptions: GCheckOptions = {
            name: opt.WebPodatelna && opt.WebPodatelna.name ? opt.WebPodatelna.name : "TypPrijmu_InterniVypraveni",
            label: opt.WebPodatelna && opt.WebPodatelna.name ? opt.WebPodatelna.name : "jres:23900239" //RC 23900239 : interní
        };

        const fieldWebPodatelnaOptions: GCheckOptions = {
            name: opt.WebPodatelna && opt.WebPodatelna.name ? opt.WebPodatelna.name : "TypPrijmu_WebPodatelna",
            label: opt.WebPodatelna && opt.WebPodatelna.name ? opt.WebPodatelna.name : "jres:23900013"
        };
        const fieldEPodatelnaPortalOptions: GCheckOptions = {
            name: opt.WebPodatelna && opt.WebPodatelna.name ? opt.WebPodatelna.name : "TypPrijmu_EPodatelnaPortal",
            label: opt.WebPodatelna && opt.WebPodatelna.name ? opt.WebPodatelna.name : "jres:23900240" //RC 23900240 : w. portál
        };

        const fieldOstatniOptions: GCheckOptions = {
            name: opt.ostatni && opt.ostatni.name ? opt.ostatni.name : "TypPrijmu_Ostatni",
            label: opt.ostatni && opt.ostatni.name ? opt.ostatni.name : "jres:23900014"
        };
        /*
        //const width = "w-4"; 
        const width = "";
        //const width = "w-3";
        const formPrefab = (new Gordic.Forms.Form({ name: "ElpodaniFiltrZpusobDorPrefabForm" }) as any)
            .addSection()
            .addRow({ label: "jres:23900010", name: "ZpusobDorFiltr", favoriteRowLayoutDescriptor: "w-L-6 w-M-8 w-S-12" })
            .addField("gcheck", width, opt.email, fieldEmailOptions)
            .addField("gcheck", width, opt.ElNosic, fieldElNosicOptions)
            .addField("gcheck", width, opt.DS, fieldDsOptions)
            .addField("gcheck", width, opt.WebPodatelna, fieldWebPodatelnaOptions)
            .addField("gcheck", width, opt.RAP, fieldRAPWebPodatelnaOptions)
            .addField("gcheck", width, opt.GEX, fieldGEXOptions)
            .addField("gcheck", width, opt.interni, fieldInterniVypraveniOptions)
            .addField("gcheck", width, opt.portal, fieldEPodatelnaPortalOptions)
            .addField("gcheck", width, opt.ostatni, fieldOstatniOptions);
        //return formPrefab.form.sections[0].rows;
        */
        var data = [
            { id: fieldEmailOptions.name, label: fieldEmailOptions.label },
            { id: fieldElNosicOptions.name, label: fieldElNosicOptions.label },
            { id: fieldDsOptions.name, label: fieldDsOptions.label },
            { id: fieldWebPodatelnaOptions.name, label: fieldWebPodatelnaOptions.label },
            { id: fieldRAPWebPodatelnaOptions.name, label: fieldRAPWebPodatelnaOptions.label },
            { id: fieldGEXOptions.name, label: fieldGEXOptions.label },
            { id: fieldInterniVypraveniOptions.name, label: fieldInterniVypraveniOptions.label },
            { id: fieldEPodatelnaPortalOptions.name, label: fieldEPodatelnaPortalOptions.label },
            { id: fieldOstatniOptions.name, label: fieldOstatniOptions.label },
        ];

        const formPrefabSelect = (new Gordic.Forms.Form({ name: "ElpodaniFiltrZpusobDorPrefabForm" }) as any) 
            .addSection()
            .addRow({ label: "jres:23900010", name: "ZpusobDorFiltr", favoriteRowLayoutDescriptor: "w-L-6 w-M-8 w-S-12" }) 
            .addField("gselectbox", {
                name: "ZpusobDorFiltr",
                multi: true,
                list: true,
                initialValue: data,
                //verticalButtons: true,
                itemTemplate: "{label}",
                itemWidth: "",
                data: new Gordic.Data.View(data, { key: "id" }),
                //initialValue: Gordic.Wfl.Prefabs.ProvizorniK203SuperFunkceObcuravaciInitialValue(settings.initialValue),
                model: function (operation, dto, modelOptions) {
                    switch (operation) {
                        case "apply":  // naplneni multivalue policka z DTO
                            var val = [];
                            if (dto[fieldEmailOptions.name]) { val.push({ id: fieldEmailOptions.name }); }
                            if (dto[fieldElNosicOptions.name]) { val.push({ id: fieldElNosicOptions.name }); }
                            if (dto[fieldDsOptions.name]) { val.push({ id: fieldDsOptions.name }); }
                            if (dto[fieldWebPodatelnaOptions.name]) { val.push({ id: fieldWebPodatelnaOptions.name }); }
                            if (dto[fieldRAPWebPodatelnaOptions.name]) { val.push({ id: fieldRAPWebPodatelnaOptions.name }); }
                            if (dto[fieldGEXOptions.name]) { val.push({ id: fieldGEXOptions.name }); }
                            if (dto[fieldInterniVypraveniOptions.name]) { val.push({ id: fieldInterniVypraveniOptions.name }); }
                            if (dto[fieldEPodatelnaPortalOptions.name]) { val.push({ id: fieldEPodatelnaPortalOptions.name }); }
                            if (dto[fieldOstatniOptions.name]) { val.push({ id: fieldOstatniOptions.name }); }

                            $(this).gfield("setValue", val, {valid:false});
                            return;
                        case "collect":
                            var value = $(this).gfield("getValue");
                            dto[fieldEmailOptions.name] = false;
                            dto[fieldElNosicOptions.name] = false;
                            dto[fieldDsOptions.name] = false;
                            dto[fieldWebPodatelnaOptions.name] = false;
                            dto[fieldRAPWebPodatelnaOptions.name] = false;
                            dto[fieldGEXOptions.name] = false;
                            dto[fieldInterniVypraveniOptions.name] = false;
                            dto[fieldEPodatelnaPortalOptions.name] = false;
                            dto[fieldOstatniOptions.name] = false;

                            if (value) {
                                for (var i = 0; i < value.length; i++) {
                                    switch (value[i].id) {
                                        case fieldEmailOptions.name:
                                            dto[fieldEmailOptions.name] = true;
                                            break;
                                        case fieldElNosicOptions.name:
                                            dto[fieldElNosicOptions.name] = true;
                                            break;
                                        case fieldDsOptions.name:
                                            dto[fieldDsOptions.name] = true;
                                            break;
                                        case fieldWebPodatelnaOptions.name:
                                            dto[fieldWebPodatelnaOptions.name] = true;
                                            break;
                                        case fieldRAPWebPodatelnaOptions.name:
                                            dto[fieldRAPWebPodatelnaOptions.name] = true;
                                            break;
                                        case fieldGEXOptions.name:
                                            dto[fieldGEXOptions.name] = true;
                                            break;
                                        case fieldInterniVypraveniOptions.name:
                                            dto[fieldInterniVypraveniOptions.name] = true;
                                            break;
                                        case fieldEPodatelnaPortalOptions.name:
                                            dto[fieldEPodatelnaPortalOptions.name] = true;
                                            break;
                                        case fieldOstatniOptions.name:
                                            dto[fieldOstatniOptions.name] = true;
                                            break;
                                        default:
                                    }
                                }
                            }

                            return;
                    }
                    return "ZpusobDorFiltr"; 
                }
            });
        return formPrefabSelect.form.sections[0].rows;
    }

    export function SekceFilterZpusobDoruceni(opt?: GRadioOptions<any>): Gordic.Forms.FormRow[]
    {
        const fieldOptions: GRadioOptions<any> = {
            name: opt && opt.name ? opt.name :  "Podepsani",
            radios: opt && opt.radios ? opt.radios :
                [
                    { value: Wfl.Interface.FiltrDlePodpisuEnum.Vsechny, label: 'jres:23900004' }, //RC 23900004 : vše
                    { value: Wfl.Interface.FiltrDlePodpisuEnum.Podepsane, label: 'jres:23900008' }, //RC 23900008 : podepsané
                    { value: Wfl.Interface.FiltrDlePodpisuEnum.Nepodepsane, label: 'jres:23900009' }, //RC 23900009 : nepodepsané
                ],
            initialValue: Wfl.Interface.FiltrDlePodpisuEnum.Vsechny,
        };

        return Gin.Prefabs.preReturn( new Gordic.Forms
            .Form({ name: "FilterDlePodepsaniPrefabForm" })
            .addSection()
            .addRow("jres:23900007") //RC 23900007 : Podpis
            .addField("gradio", opt, fieldOptions));
    }
}